// extracted by mini-css-extract-plugin
export default {"background":"index_background__3NqR5"};